import posSearchController from "./options/positionsearch.ctrl";
import {routerConfig} from "./RouterConfig";
import {equityPositionsView, EquityPositionsView} from "./equities/EquitiesPositionViewComponent";
import {AdviserPositionsService} from "./service/AdviserPositionsService";

export default angular.module("tf.positions", [])
                      .controller("posSearchCtrl", posSearchController)
                      .component(EquityPositionsView, equityPositionsView())
                      .service(AdviserPositionsService.id, AdviserPositionsService)
                      .config(routerConfig)
                      .name;
